// extracted by mini-css-extract-plugin
export default {"wrapper":"Intro_wrapper__hDefR","title":"Intro_title__D3fYM","paragraph":"Intro_paragraph__G+T6j","row":"Intro_row__5M4mX"};